import React from 'react';

const VisionOrderTypeFilter = ({ onChange, currentFilter }) => {
  const handleChange = (event) => {
    const value = event.target.value;
    const filterValue = value === '' ? null : value;
    onChange(filterValue);
  };

  return (
    <select
      onChange={handleChange}
      style={{
        width: '100%',
        height: '40px',
        fontSize: '12px',
        borderRadius: '10px',
      }}
      value={currentFilter || ''}
    >
      <option value="">All</option>
      <option value="inStore">In Store</option>
      <option value="online">Online</option>
    </select>
  );
};

export default VisionOrderTypeFilter;
